;(function () {
	const timers = new WeakMap()
	const splits = new WeakMap()

	const clearTimers = (text) => {
		;(timers.get(text) || []).forEach((t) => clearTimeout(t))
		timers.set(text, [])
	}

	const addTimer = (text, fn, ms) => {
		const list = timers.get(text) || []
		list.push(setTimeout(fn, ms))
		timers.set(text, list)
	}

	const splitHeadings = (root) => {
		if (typeof SplitType === 'undefined') return
		root.querySelectorAll('.js-split-text').forEach((heading) => {
			const instance = splits.get(heading)
			if (instance) {
				instance.split()
			} else {
				splits.set(heading, new SplitType(heading))
			}
			heading.classList.add('visible')
		})
	}

	const resetText = (text) => {
		if (!text) return
		clearTimers(text)
		text.querySelectorAll('.js-split-text .line').forEach((line) => {
			line.classList.remove('animated')
			line.style.overflow = 'hidden'
			Array.from(line.children).forEach((el) => {
				el.style.animationDelay = ''
			})
		})
		text.querySelectorAll('.js-fade').forEach((item) => {
			item.classList.remove('visible')
		})
	}

	const playText = (text, delay = 0) => {
		if (!text) return
		resetText(text)
		void text.offsetWidth
		const lines = text.querySelectorAll('.js-split-text .line')
		lines.forEach((line, i) => {
			const lineDelay = delay + i * 0.25
			Array.from(line.children).forEach((el) => {
				el.style.animationDelay = `${lineDelay}s`
			})
			line.classList.add('animated')
			addTimer(text, () => {
				line.style.overflow = 'visible'
			}, lineDelay * 1000 + 600)
		})
		addTimer(text, () => {
			text.querySelectorAll('.js-fade').forEach((item) => {
				item.classList.add('visible')
			})
		}, delay * 1000 + lines.length * 250 + 200)
	}

	const initSection = (section) => {
		if (section.classList.contains('slider_started')) return
		section.classList.add('slider_started')

		const id = section.id
		const box = $(section).find('.slideshow')
		if (!box.length) return

		const boxEl = box[0]
		const autoplay = box.data('autoplay')
		const stopAutoplay = box.data('stop-autoplay')
		const delay = box.data('delay') * 1000
		const speed = box.data('speed') * 1000
		const speedSec = Number(box.data('speed')) || 0
		const isCustom = box.data('effect') == 'custom'
		const effect = isCustom ? 'fade' : box.data('effect')
		const animated = !!section.querySelector('.slideshow-slide__text--animation')

		const setSlideWidth = () => {
			const container = section.querySelector('.container')
			if (!container) return
			const cs = window.getComputedStyle(container)
			const ss = window.getComputedStyle(section)
			const sectionWidth = section.clientWidth - parseFloat(ss.paddingLeft) - parseFloat(ss.paddingRight)
			const widthSlide = sectionWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)
			section.style.setProperty('--width-slide', `${widthSlide}px`)
		}

		setSlideWidth()
		if (animated) splitHeadings(section)

		let zIndex = $(section).find('.slideshow-swiper__slide').length
		const autoplayParm = autoplay
			? {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true
					}
			  }
			: {}

		const swiper = new Swiper(`#${id} .slideshow__swiper`, {
			parallax: box.data('parallax'),
			effect: effect,
			virtualTranslate: effect == 'custom',
			watchSlidesProgress: true,
			speed: speed,
			loop: false,
			centeredSlides: false,
			autoHeight: false,
			calculateHeight: false,
			keyboard: true,
			fadeEffect: {
				crossFade: true
			},
			creativeEffect: {
				prev: {
					shadow: false,
					translate: [0, 0, -400]
				},
				next: {
					translate: ['100%', 0, 0]
				}
			},
			coverflowEffect: {
				rotate: 50,
				stretch: 0,
				depth: 100,
				modifier: 1,
				slideShadows: false
			},
			pagination: {
				el: `#${id} .swiper-pagination`,
				clickable: 'true',
				type: 'bullets'
			},
			...autoplayParm,
			on: {
				init: function () {
					if (isCustom) {
						const firstSlide = this.slides[0]
						if (firstSlide && firstSlide.classList.contains('swiper-slide-active')) {
							firstSlide.classList.add('no-animation')
						}
					}
				}
			}
		})

		let inView = false

		const textOf = (slide) => (slide ? slide.querySelector('.slideshow-slide__text--animation') : null)
		const activeText = () => textOf(swiper.slides[swiper.activeIndex])
		const resetAll = () => swiper.slides.forEach((slide) => resetText(textOf(slide)))
		const resetInactive = () => {
			swiper.slides.forEach((slide, i) => {
				if (i !== swiper.activeIndex) resetText(textOf(slide))
			})
		}

		const refreshText = () => {
			setSlideWidth()
			splitHeadings(section)
			resetAll()
			if (inView) playText(activeText(), 0)
		}

		const swiperContainer = swiper.el.querySelector('.swiper-wrapper')
		if (isCustom && autoplay && stopAutoplay && swiperContainer) {
			swiperContainer.addEventListener('mouseenter', () => {
				swiper.autoplay.stop()
			})
			swiperContainer.addEventListener('mouseleave', () => {
				swiper.autoplay.start()
			})
		}

		swiper.on('transitionStart', function () {
			if (isCustom) {
				zIndex = zIndex + 1
				this.slides[this.activeIndex].style.setProperty('z-index', `${zIndex}`)
			}
		})

		swiper.on('transitionEnd', function () {
			if (animated) resetInactive()
		})

		swiper.on('beforeTransitionStart', function () {
			colorScheme(this)
		})

		swiper.on('slideChange', function () {
			box.css('--bullet-duration', `${delay + speed}ms`)
			colorScheme(this)

			if (animated && inView) playText(activeText(), speedSec)

			if (isCustom) {
				const firstSlide = this.slides[0]
				if (firstSlide) firstSlide.classList.remove('no-animation')

				if (autoplay && this.params.autoplay.waitForTransition == true) {
					this.params.autoplay.delay = delay + speed
					this.params.autoplay.waitForTransition = false
					this.autoplay.stop()
					this.autoplay.start()
				}
			}
		})

		function colorScheme(context) {
			const parent = box.find('.slideshow-bottom')
			const activeSlide = context.slides[context.activeIndex]
			const scheme = $(activeSlide).find('.slideshow-slide').data('color-scheme')
			const item = parent[0]
			if (!item || !scheme) return
			Array.from(item.classList).forEach((className) => {
				if (/color-background-\d+$/.test(className)) item.classList.remove(className)
			})
			item.classList.add(scheme)
		}

		if (animated) {
			const textObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && !inView) {
						inView = true
						playText(activeText(), speedSec)
					} else if (!entry.isIntersecting && inView) {
						inView = false
						resetAll()
					}
				})
			})
			textObserver.observe(boxEl)

			if (document.fonts && document.fonts.status !== 'loaded') {
				document.fonts.ready.then(refreshText)
			}
		}

		let lastWidth = Math.round(section.clientWidth)
		let resizeTimer
		const resizeObserver = new ResizeObserver(() => {
			const width = Math.round(section.clientWidth)
			if (width === lastWidth) return
			lastWidth = width
			setSlideWidth()
			if (!animated) return
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(refreshText, 200)
		})
		resizeObserver.observe(section)
	}

	const slideshow = () => {
		document.querySelectorAll('.slideshow-section').forEach(initSection)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', slideshow)
	} else {
		slideshow()
	}

	document.addEventListener('shopify:section:load', slideshow)
})()